import RedeemVoucher from '@/models/storePanel/redeem/RedeemVoucher';
const getDefaultState = () => ({
  voucher: '',
  redeemNotification: {},
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setVoucher(state, payload) {
      state.voucher = payload;
    },

    setRedeemNotification(state, payload) {
      state.redeemNotification = payload;
    },
  },

  actions: {
    async create({ commit }, item) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await RedeemVoucher.create(item);
        commit('setRedeemNotification', data.data.gift);
        commit('setDialog', true, { root: true });
        commit('setVoucher', '');
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'Success Redemption',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        // commit("setErrorMessage", ex.response.data.message, {
        //     root: true
        // });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
      }
    },
  },
};
